(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 document.querySelectorAll('.green-nav-dropdown[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
});
document.addEventListener('keydown',event=>{
 if(event.key==='Escape')document.querySelectorAll('.green-nav-dropdown[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["green-product-heading"] && !Shopify.designMode) return;
  try {
    class GreenProductHeading extends HTMLElement {
  connectedCallback() { this.section = this.closest('.shopify-section'); this.section?.addEventListener('shopify:product:select',this.update); }
  disconnectedCallback() { this.section?.removeEventListener('shopify:product:select',this.update); }
  update = (event) => {
    if (event.target.closest('product-card')) return;
    event.promise.then(({detail}) => {
      const next = detail?.html?.querySelector(`green-product-heading[data-block-id="${this.dataset.blockId}"]`);
      if (next) this.replaceChildren(...Array.from(next.childNodes));
      this.section?.querySelectorAll('[data-green-variant-links]').forEach((links) => {
        const replacement = detail.html.querySelector(`[data-green-variant-links="${links.dataset.greenVariantLinks}"]`);
        if (replacement) links.replaceChildren(...Array.from(replacement.childNodes));
      });
    }).catch(() => {});
  };
}
if (!customElements.get('green-product-heading')) customElements.define('green-product-heading',GreenProductHeading);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["green-purchase-option"] && !Shopify.designMode) return;
  try {
    class GreenPurchaseOptions extends HTMLElement {
 connectedCallback(){
  this.section=this.closest('.shopify-section');
  this.data=JSON.parse(this.querySelector('[data-plan-data]').textContent);
  this.addEventListener('change',this.update);
  document.addEventListener('shopify:product:select',this.refresh);
  this.refresh();
 }
 disconnectedCallback(){this.removeEventListener('change',this.update);document.removeEventListener('shopify:product:select',this.refresh);clearTimeout(this.timer);}
 refresh=(event)=>{
  if(event?.promise){event.promise.then(({detail})=>{
    const next=detail?.html?.querySelector(`green-purchase-options[data-form="${this.dataset.form}"]`);
    if(next){this.dataset.variant=next.dataset.variant;this.querySelector("[data-once-price]").textContent=next.querySelector("[data-once-price]").textContent;}
    this.refresh();
  }).catch(()=>{});return;}
  clearTimeout(this.timer);this.timer=setTimeout(()=>{
  const form=document.getElementById(this.dataset.form);
  const id=form?.querySelector('[name="id"]')?.value||this.dataset.variant;
  const plans=this.data.variants[id]||[];
  const select=this.querySelector('select');const previous=select.value;
  select.replaceChildren(...plans.map(p=>{
    const days=p.name.match(/^(\d+)\s+day\b/i);
    const label=days?this.data.everyDays.replace('[days]',days[1]):p.name;
    return new Option(`${label} · ${p.price}`,p.id);
  }));
  if(plans.some(p=>String(p.id)===previous))select.value=previous;
  this.update();
 },50);};
 update=()=>{
  const recurring=this.querySelector('input[value="subscription"]').checked;
  const select=this.querySelector('select');const available=select.options.length>0;
  const pending=recurring&&!available;
  this.toggleAttribute('data-recurring',recurring);
  const form=document.getElementById(this.dataset.form);
  const variantId=form?.querySelector('[name="id"]')?.value||this.dataset.variant;
  const selectedPlan=(this.data.variants[variantId]||[]).find(p=>String(p.id)===select.value);
  const displayPrice=recurring&&selectedPlan?selectedPlan:this.data.once[variantId];
  if(displayPrice){
    this.section?.querySelectorAll('product-price .price bdi').forEach(el=>{el.textContent=displayPrice.price;});
    this.section?.querySelectorAll('product-price .green-pdp-note').forEach(el=>{el.textContent=`${displayPrice.unitPrice} ${this.data.perServing}`;});
    this.querySelector('[data-once-price]').textContent=this.data.once[variantId].price;
  }
  this.querySelector('.green-subscription-details').hidden=!recurring;
  this.querySelector('.green-subscription-frequency').hidden=!available;
  this.querySelector('.green-plan-note').textContent=available?this.data.recurring:this.data.pending;
  const input=this.querySelector('[name="selling_plan"]');input.disabled=!recurring||!available;input.value=recurring?select.value:'';
  this.querySelector('.green-subscription-button').hidden=!pending;
  this.section?.querySelectorAll('.buy-buttons-block').forEach(el=>{el.hidden=pending;});
  this.section?.querySelectorAll('.shopify-payment-button').forEach(el=>{el.hidden=recurring;});
  const bar=this.section?.querySelector('sticky-add-to-cart');if(bar)bar.hidden=recurring;
 };
}
if(!customElements.get('green-purchase-options'))customElements.define('green-purchase-options',GreenPurchaseOptions);
  } catch(e) { console.error(e); }
})();

})();
